import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { interval, Observable } from "rxjs";
import { PerfilUserRequest } from './interfaces/perfil-user.request';
import { PerfilUserResult } from './interfaces/perfil-user.result';
import { PerfilUserInteractor } from '../interactor/perfil-user.interactor';
import { PerfilForm } from '../../../../interfaces/perfil-form.interface';

import { map, take } from "rxjs/operators";
import { GlobalRequest } from '../../../../services/global/presenter/global.request';
import { GlobalInteractor } from '../../../../services/global/interactor/global.interactor';
import { User } from "../../../../models/user.model";
import { IsRequestComplete } from "../../../../interfaces/isrequest-complete";
import { ImageGestion } from "../../../../utilities/img-gestion/classes/img-gestion";
import { ImgGestion } from "../../../../utilities/img-gestion/img-gestion.utilities";




@Injectable({
providedIn:'root'}
)
export class PerfilUserPresenter implements GlobalRequest, PerfilUserRequest, PerfilUserResult {


private result: PerfilUserResult;
private _isRequestComplete: IsRequestComplete;
private imgGestionAbs: ImageGestion;

constructor(private interactor: PerfilUserInteractor,
            private globalInteractor: GlobalInteractor,
            private imgGestion: ImgGestion){
this.imgGestionAbs = imgGestion;
globalInteractor.setPresenter(this);
interactor.setPresenter(this);
}

setRequestCompleteComponent(isRequestComplete: IsRequestComplete){
  this._isRequestComplete = isRequestComplete;
}
setComponent(result: PerfilUserResult){
  this.result = result;
}

isRequestComplete(status: boolean, error?: HttpErrorResponse): void {
  this._isRequestComplete.isRequestComplete(status, error);
}
isEditedResponse(response: any): void {
 this.result.isEditedResponse(response);
}
isUpdatedPasswordResponse(response: any): void {
  this.result.isUpdatedPasswordResponse(response);
}

getUser(): User {
  return this.globalInteractor.getUser();
}
setUserPerfil(user: User) {
  this.globalInteractor.setUser(user);
}

updatePasword(data: any): void {
  this.interactor.updatePasword(data);
}

getImageSubir(file: File) {
 this.result.getImageSubir(file);
}
getImgTmp(file: File) {
 this.result.getImgTmp(file);
}


uploadImage(user: User): void {
 this.imgGestionAbs.subirImagenUsuario(user);
}

changeImage(file: File): void {
this.imgGestionAbs.cambiarImagen(file);
this.getImageSubir(this.imgGestionAbs.imagenSubir);
this.returnIntervalo().subscribe(res=>this.getImgTmp(res));
}

 updatePerfil(perfilForm: PerfilForm){
   this.interactor.updatePerfil(perfilForm);
  }


observerImgTemp(): Observable<File>{
let i = 0;
return  new Observable<File>(observer=>{
   const intervalo = setInterval(()=>{
    i++
    observer.next(this.imgGestionAbs.imgTemp);
    if(i == 5){
      clearInterval(intervalo);
      observer.complete();
     }
    },200)
});
}
returnIntervalo(): Observable<File>{
return interval(100)
.pipe(
take(5),
map(res => this.imgGestionAbs.imgTemp)
)
}


}
